// Application settings
const APP_CONFIG = {
    NAME: 'Budget Manager',
    VERSION: '1.0.0',
    COPYRIGHT: `© ${new Date().getFullYear()} Budget Manager`,
    
    // Feature flags
    FEATURES: {
      ENABLE_NOTIFICATIONS: true,
      ENABLE_DATA_MIGRATION: process.env.NODE_ENV === 'development',
      ENABLE_ANALYTICS: process.env.NODE_ENV === 'production',
      DEBUG_MODE: process.env.NODE_ENV === 'development',
    },
    
    // Pagination defaults
    PAGINATION: {
      ITEMS_PER_PAGE: 10,
      MAX_PAGES: 10,
    },
    
    // Date format options
    DATE_FORMAT: 'MMMM DD, YYYY',
    TIME_FORMAT: 'HH:mm',
    DATETIME_FORMAT: 'MMMM DD, YYYY HH:mm',
  };
  
  export default APP_CONFIG;